export enum LeadsReportStateEnum {
    DEFAULT,
    EMPTY,
    SUCCESS,
    ERROR,
}